<template>
    <div class="credential-brands" :style="{ height: size + unit, gap: size * .5 + unit }">
        <img class="credential-wordmark" :src="wordmark" alt="Next Idea Matters">
        <span v-if="trackLogo" class="credential-track" :style="trackFrameStyle">
            <img :src="trackLogo" :alt="trackName" :style="trackImageStyle">
        </span>
    </div>
</template>
<script>
import wordmark from '../assets/nim-wordmark.png'
// Optical bounds of the existing artwork, excluding each PNG's transparent margins.
// The main wordmark's blue lettering spans y=7..98 in its 270×124 source;
// the grey tagline is intentionally outside the track alignment band.
const TRACK_ARTWORK = [
    [require('../assets/nsi_logo.png'), 1865, 740, 135, 120, 1581, 500],
    [require('../assets/nri_logo.png'), 1865, 741, 135, 120, 1564, 500],
    [require('../assets/nir_logo.png'), 1463, 585, 135, 102, 1186, 356],
    [require('../assets/nia_logo.png'), 1534, 585, 135, 102, 1266, 357],
    [require('../assets/nie_logo.png'), 1463, 585, 135, 102, 1201, 356],
    [require('../assets/nip_logo.png'), 1279, 585, 135, 102, 1008, 357],
    [require('../assets/nii_logo.png'), 1287, 585, 135, 102, 1008, 357],
    [require('../assets/niv_logo.png'), 1353, 585, 135, 103, 1071, 356]
]


export default {
    name: 'CredentialBrandLockup',
    props: {
        trackLogo: { type: String, default: '' }, trackName: { type: String, default: '' },
        size: { type: Number, default: 4.8 }, unit: { type: String, default: 'cqw' }
    },
    data: () => ({ wordmark }),
    computed: {
        trackArtwork() { return TRACK_ARTWORK.find(art => art[0] === this.trackLogo) },
        trackFrameStyle() {
            const art = this.trackArtwork
            const height = this.size * 91 / 124
            return {
                width: `${art ? height * art[5] / art[6] : this.size * 2.5}${this.unit}`,
                height: `${height}${this.unit}`, marginTop: `${this.size * 7 / 124}${this.unit}`
            }
        },
        trackImageStyle() {
            const art = this.trackArtwork
            if (!art) return { width: '100%', height: '100%', objectFit: 'contain' }
            const [, width, height, x, y, inkWidth, inkHeight] = art
            return {
                width: `${100 * width / inkWidth}%`, height: `${100 * height / inkHeight}%`,
                left: `${-100 * x / inkWidth}%`, top: `${-100 * y / inkHeight}%`
            }
        }
    }
}
</script>
<style scoped>
.credential-brands { display:flex; justify-content:center; align-items:flex-start; }
.credential-wordmark { display:block; width:auto; height:100%; }
.credential-track { display:block; position:relative; flex:none; overflow:hidden; }
.credential-track img { position:absolute; display:block; max-width:none; }
</style>
